document.addEventListener("DOMContentLoaded", function () {

    const carousel = document.getElementById("carousel_move");
    const dotsContainer = document.getElementById("dots");

    if (!carousel || !dotsContainer) return;

    const slides = Array.from(
        carousel.querySelectorAll(":scope > .slide")
    );

    const slideCount = slides.length;

    if (slideCount < 2) return;

    let currentIndex = 0;
    let isTransitioning = false;
    let timer;

    const duration = 600;
    const delay = 10000;

    // Create navigation dots
    dotsContainer.innerHTML = "";

    slides.forEach((_, index) => {

        const dot = document.createElement("div");
        dot.classList.add("dot");

        if (index === 0) {
            dot.classList.add("active");
        }

        dot.addEventListener("click", () => {
            moveToSlide(index);
        });

        dotsContainer.appendChild(dot);
    });

    const dots = Array.from(
        dotsContainer.querySelectorAll(".dot")
    );

    function updateDots() {

        dots.forEach((dot, index) => {
            dot.classList.toggle(
                "active",
                index === currentIndex
            );
        });

    }

    function getSlideWidth() {
        return carousel.parentElement.getBoundingClientRect().width;
    }

    function updatePosition(animate = true) {

        const width = getSlideWidth();

        carousel.style.transition = animate
            ? `transform ${duration}ms ease-in-out`
            : "none";

        carousel.style.transform =
            `translateX(-${currentIndex * width}px)`;

    }

    function resetTimer() {

        clearTimeout(timer);

        timer = setTimeout(() => {
            moveToSlide((currentIndex + 1) % slideCount);
        }, delay);

    }

    function moveToSlide(targetIndex) {

        if (isTransitioning) return;

        clearTimeout(timer);

        if (targetIndex === currentIndex) {
            resetTimer();
            return;
        }

        isTransitioning = true;
        currentIndex = targetIndex;

        updateDots();
        updatePosition(true);

        setTimeout(() => {
            isTransitioning = false;
            resetTimer();
        }, duration);

    }

    // Initialize carousel at first slide
    updatePosition(false);
    updateDots();

    // Keep slide alignment correct when resizing
    window.addEventListener("resize", () => {
        updatePosition(false);
    });

    // Start automatic rotation
    resetTimer();

});